import { render, staticRenderFns } from "./DoctorVerifyPayPage.vue?vue&type=template&id=faf1442a&scoped=true"
import script from "./DoctorVerifyPayPage.vue?vue&type=script&lang=js"
export * from "./DoctorVerifyPayPage.vue?vue&type=script&lang=js"
import style0 from "./DoctorVerifyPayPage.vue?vue&type=style&index=0&id=faf1442a&prod&scoped=true&lang=css"
import style1 from "./DoctorVerifyPayPage.vue?vue&type=style&index=1&id=faf1442a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf1442a",
  null
  
)

export default component.exports